import {
  type ChangeEvent,
  memo,
  useCallback,
  useEffect,
  useState,
} from 'react';

import { Textarea } from 'darrius';

import { useDebounce } from '../../../../../../hooks/useDebounce';
import { useForm } from '../../../../hooks/useForm';

import { type ITextareaControlProps } from './@interfaces';

export function TextareaControlComponent({
  placeholder,
  path,
  handleChange,
  shouldHaveMaxLength = false,
  maxLength
}: ITextareaControlProps) {
  const debounceChange = useDebounce(handleChange, 500);

  const { form } = useForm();

  const [textAreaDisplayvalue, setTextAreaDisplayValue] = useState('');
  const [textLength, setTextLength] = useState<number>(0)

  useEffect(() => {
    if (form[path] && textAreaDisplayvalue === '') {
      setTextAreaDisplayValue(form[path]);
    }
  }, [form, path, textAreaDisplayvalue]);

  const onChange = useCallback(
    (ev: ChangeEvent<HTMLTextAreaElement>) => {
      setTextAreaDisplayValue(ev.target.value);
      if(shouldHaveMaxLength) setTextLength(ev.target.value.length)

      debounceChange(path, ev.target.value);
    },
    [debounceChange, path]
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
        }}
      >
        <Textarea
          placeholder={placeholder}
          onChange={onChange}
          rows={10}
          value={textAreaDisplayvalue}
          maxLength={maxLength}
          style={{
            width: '100%',
            paddingBottom: '30px',
          }}
        />
        {(shouldHaveMaxLength && maxLength) && (
          <div
            style={{
              position: 'absolute',
              bottom: '4px',
              right: 0,
              color: 'black',
              fontSize: '0.9rem',
              padding: '2px 6px',
              borderRadius: '4px',
            }}
          >
            <p style={{ margin: 0 }}>{textLength}/{maxLength}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export const TextareaControl = memo(TextareaControlComponent);
